module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/fj-55dd1c6e9a323130d8e763f7a6971c8d.svg";